<template>
  <div>

    <!-- Exibe a lista de produtos -->
    <div :class="isInputError('products')" @click="removeError('products')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">{{ $t('views.seller.integrations.config.save.product.title') }}</strong>
        <a href="#" @click.prevent="selectAll('products')" class="select-all float-right">
          {{ products?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="products.value"
        :options="products.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :limit-text="limitText" 
        :limit="4" 
        :searchable="true"
        :loading="loadingProducts"
        :group-select="true"
        :select-label="'Select'"
        :disabled="loading"
        class="new-style"
        group-values="options"
        group-label="group"
        :placeholder="$t('views.seller.integrations.config.save.product.search')" 
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="option__title" v-if="props.option?.$isLabel">
            {{ props.option.$groupLabel.name }}
            <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.save.product.select_all') }}</span>
            <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.save.product.remove_all') }}</span>
          </span>
          <span class="d-flex option__item" v-else>
            <img :src="isOptionSelected('products', props.option.id)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">{{ $t('views.seller.integrations.config.save.product.select') }}</span>
        </template>
        <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
        <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
        <div slot="limit" class="multiselect__tag limit">+{{ products?.value?.length - 4 }}</div>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('products') }}</span>
    </div>

    <!-- Exibe o token -->
    <div :class="isInputError('token')" @click="removeError('token')">
      <strong class="title-medium mt-4">API Key <b class="optional">(Admin v1)</b></strong>
      <b-form-group id="fieldset-token" label-for="input-token">
        <b-form-input id="input-token" :placeholder="`Informe o API Key do ${integration.name}`" class="form-input" v-model="token" :disabled="loading" @change="updateConnection" trim></b-form-input>
      </b-form-group>
      <span class="show-error">
        {{ showError('token') }}
      </span>
    </div>

    <!-- Exibe comunidades -->
    <div :class="isInputError('community')" @click="removeError('community')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Comunidade</strong>
      </div>
      <multiselect 
        v-model="community.value"
        :options="community.items" 
        :multiple="false" 
        :show-labels="false"
        :searchable="false"
        :loading="community.loading"
        :disabled="community.block"
        @input="listItemsCircle"
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a comunidade desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('community') }}</span>
    </div>

    <!-- Exibe grupos de espaços -->
    <div :class="isInputError('space_group')" @click="removeError('space_group')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Grupos de Espaços <b class="optional">(opcional)</b></strong>
        <a href="#" @click.prevent="selectAll(space_group)" class="select-all float-right">
          {{ space_group?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="space_group.value"
        :options="space_group.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :searchable="true"
        :loading="space_group.loading"
        :disabled="space_group.block"
        :limit-text="limitText" 
        :select-label="'Select'"
        :limit="4" 
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">
            <img :src="isOptionSelected('space_group', props.option.id, null, space_group)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione os grupos de espaços desejados</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <div slot="limit" class="multiselect__tag limit">+{{ space_group?.value?.length - 4 }}</div>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('space_group') }}</span>
    </div>

    <!-- Exibe espaços -->
    <div :class="isInputError('space')" @click="removeError('space')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Espaços <b class="optional">(opcional)</b></strong>
        <a href="#" @click.prevent="selectAll(space)" class="select-all float-right">
          {{ space?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="space.value"
        :options="space.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :searchable="true"
        :loading="space.loading"
        :disabled="space.block"
        :limit-text="limitText" 
        :select-label="'Select'"
        :limit="4" 
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">
            <img :src="isOptionSelected('space', props.option.id, null, space)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione os espaços desejados</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <div slot="limit" class="multiselect__tag limit">+{{ space?.value?.length - 4 }}</div>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('space') }}</span>
    </div>

    <!-- Exibe tags -->
    <div :class="isInputError('tag')" @click="removeError('tag')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Tags <b class="optional">(opcional)</b></strong>
        <a href="#" @click.prevent="selectAll(tag)" class="select-all float-right">
          {{ tag?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="tag.value"
        :options="tag.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :searchable="true"
        :loading="tag.loading"
        :disabled="tag.block"
        :limit-text="limitText" 
        :select-label="'Select'"
        :limit="4" 
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">
            <img :src="isOptionSelected('tag', props.option.id, null, tag)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione as tags desejadas</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <div slot="limit" class="multiselect__tag limit">+{{ tag?.value?.length - 4 }}</div>
        <span slot="noResult">Nenhum item encontrado</span>
        <span slot="noOptions">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('tag') }}</span>
    </div>

    <!-- Botao Salvar -->
    <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveItegration">
      <template v-if="loadingSave">
        <b-spinner variant="light" class="mr-2" small></b-spinner>
        {{ $t('views.seller.integrations.config.save.button.saving') }}
      </template>
      <template v-else>
        {{ $t('views.seller.integrations.config.save.button.save') }}
      </template>
    </b-button>

  </div>
</template>

<script>

import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import CircleService from "@/services/resources/CircleService";
import CallbackService from '@/services/resources/CallbackService';

export default {
  name: "IntegrationsConfigCircle",
  components: {
    Multiselect
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Circle' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    selectAll: {
      type: Function,
      required: true
    },
    isOptionSelected: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    updateCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => {
    return {
      loadingSave: false,
      url: 'https://app.circle.so/api/v1',
      token: '',
      community: {
        block: true,
        loading: false,
        value: null,
        items: [],
      },
      space: {
        block: true,
        loading: false,
        value: null,
        items: [],
      },
      space_group: {
        block: true,
        loading: false,
        value: null,
        items: [],
      },
      tag: {
        block: true,
        loading: false,
        value: null,
        items: [],
      },
    }
  },
  methods: {
    resetForm() {
      this.products.value = null;
      this.token = '';
      this.community.value = null;
      this.community.block = true;
      this.space_group.value = null;
      this.space_group.block = true;
      this.space.value = null;
      this.space.block = true;
      this.tag.value = null;
      this.tag.block = true;
    },
    updateConnection() {
      if (this.token) {
        CircleService.build().read(`test?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true })
        .then(() => {

          // Lista comunidades
          this.community.loading = true;
          this.community.block = false;
          this.community.value = [];

          CircleService.build().read(`community?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true })
          .then(response => {
            this.community.items = response.map(item => {
              return {
                id: item.id,
                name: item.name
              }
            });
          })
          .catch(() => {
            this.community.items = [];
          })
          .finally(() => {
            this.community.loading = false;
          });
        })
        .catch(err => {
          this.community.block = true;
          this.community.value = [];
          this.mountInputError(err.response.data);

          const items = ['community', 'space', 'space_group', 'tag'];
          for (const item of items) {
            this[item].block = true;
            this[item].value = [];
          }
        })
        .finally(() => {
          this.community.loading = false;
        });
      }
    },
    listItemsCircle(selectedValue) {

      if (!selectedValue) {
        const items = ['space', 'space_group', 'tag'];
        for (const item of items) {
          this[item].block = true;
          this[item].value = [];
        }
        return;
      }

      this.listSpacesCircle(selectedValue);
      this.listSpacesGroupCircle(selectedValue);
      this.listTagsCircle(selectedValue);
    },
    listSpacesCircle(selectedValue) {
      // Lista spaces
      this.space.loading = true;
      this.space.block = false;
      this.space.value = [];

      CircleService.build().read(`community/${selectedValue.id}/spaces?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true })
      .then(response => {
        this.space.items = response.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        });
      })
      .catch(() => {
        this.space.items = [];
      })
      .finally(() => {
        this.space.loading = false;
      });
    },
    listSpacesGroupCircle(selectedValue) {
      // Lista spaces group
      this.space_group.loading = true;
      this.space_group.block = false;
      this.space_group.value = [];

      CircleService.build().read(`community/${selectedValue.id}/space_groups?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true })
      .then(response => {
        this.space_group.items = response.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        });
      })
      .catch(() => {
        this.space_group.items = [];
      })
      .finally(() => {
        this.space_group.loading = false;
      });
    },
    listTagsCircle(selectedValue) {
      // Lista tags
      this.tag.loading = true;
      this.tag.block = false;
      this.tag.value = [];

      CircleService.build().read(`community/${selectedValue.id}/tags?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true })
      .then(response => {
        this.tag.items = response.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        });
      })
      .catch(() => {
        this.tag.items = [];
      })
      .finally(() => {
        this.tag.loading = false;
      });
    },
    saveItegration() {

      const products = this.products?.value?.map(product => product.id) || [];
      const community = this.community?.value || null;
      const spaces = this.space?.value || [];
      const space_groups = this.space_group?.value || [];
      const tags = this.tag?.value || [];

      CallbackService.build().create({
        url: this.url,
        token: this.token,
        products: products,
        events: [{"trigger":"salePaid"},{"trigger":"saleRefunded"}], // Venda paga e Venda reembolsada
        community,
        spaces,
        space_groups,
        tags,
        action: {
          value: 'executarCircle',
        }
      }, null, `integrations/group/${this.integration.id}?ignore_args=true`, { suppressErrorNotify: true })
      .then((response) => {
        if (response?.confirm_update?.length > 0) {

          const dataUpdate = {
            url: this.url,
            token: this.token,
            community,
            spaces,
            space_groups,
            tags
          };

          this.confirmUpdate(response.confirm_update, dataUpdate);
        }
        else {
          this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
            title: this.$t('views.seller.integrations.config.toast.save.success.title'),
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }

        this.resetForm();
        this.fetchCallbacks();
      })
      .catch(err => {
        this.mountInputError(err.response.data);
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
      });
    },
    confirmUpdate(data, dataUpdate) {

      Vue.swal({
        title: this.$t('views.seller.integrations.config.alert.update.title'),
        html: `<p>${this.$t('views.seller.integrations.config.alert.update.message')}</p>
        <ul>
          ${data.map(item => `<li>${item.product_name}</li>`).join('')}
        </ul>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('views.seller.integrations.config.alert.update.ok'),
        cancelButtonText: this.$t('views.seller.integrations.config.alert.update.cancel'),
        customClass: "sweet-container-new",
        confirmButtonClass: "btn btn-primary text-nowrap",
        cancelButtonClass: "btn btn-outline-secondary text-nowrap",
        buttonsStyling: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateCallbacks({
            force_update: true,
            products: data, 
            dataUpdate: dataUpdate
          });
        }
      });
    },
  }
}
</script>